import { render, staticRenderFns } from "./ContactFieldHeader.vue?vue&type=template&id=163d67a4&"
import script from "./ContactFieldHeader.vue?vue&type=script&lang=ts&"
export * from "./ContactFieldHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports